import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material';

import { Material } from '../../_models/material';
import { MaterialsService } from '../../shared/materials.service';

@Component({
  moduleId: module.id,
  templateUrl: 'modify-material.component.html',
  styleUrls: ['./modify-material.component.css']
})

export class ModifyMaterialComponent implements OnInit {
  public materialForm: FormGroup;
  public material: Material;
  public formTitle: string;
  public newMaterial: File = null;
  public stores: number[] = [];

  constructor(private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public data: any,
              public materialsService: MaterialsService) {}


  onBasicUpload(event: any) {
    this.newMaterial = event.srcElement.files[0];
  }

  ngOnInit(): void {
    for (let store of this.materialsService.stores) {
      this.stores.push(store.id);
    }
    if (this.data) {
      this.material = this.data.material;
      this.formTitle = 'Edit ' + this.material.name;
    } else {
      this.formTitle = 'Upload new material';
      this.material = new Material();
    }
    this.materialForm = this.formBuilder.group({
      name: [this.material.name, Validators.required],
      category: [this.material.category, Validators.required],
      start_date: [this.material.start_date, Validators.required],
      end_date: [this.material.end_date],
      comments: [this.material.comments],
      stores_ids: [this.material.stores_ids],
      push: [false],
    });
  }

  selectAllStores(): void {

    this.materialForm.patchValue({
      'stores_ids': this.stores
    });
  }

  deselectStores(): void {
    this.materialForm.patchValue({
      'stores_ids': []
    });
  }
}




// WEBPACK FOOTER //
// /app/src/app/hq/materials/modify-material.component.ts